import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import React, { useEffect, useMemo } from "react";

import {
  getCrews,
  editCrewOnSubmit,
  initializeEditCrew,
  createCrewOnSubmit,
  deleteCrew,
} from "features/planner/planner.actions";

import {
  getSummarizedDataStatesFromState,
  getCurrentUserAppRolesFromState,
} from "app/app.selectors";

import CrudBasePage from "app/components/CrudBasePage";
import { getAccessControlButton } from "utils/component.util";
import { SORT_DIRECTION } from "features/planner/planner.constants";
import { getCrewsFromState } from "features/planner/planner.selectors";
import { ACTIONS, CREW_FORM } from "features/planner/planner.constants";
import CrewForm from "features/planner/settings/crew/components/CrewForm";
import { getModifiedByValue, hasRequiredAccessLevel } from "utils/app.util";

const SettingsCrewContainer = ({
  Icon,
  crews,
  dataState,
  breadcrumb,
  crudAccessLevel,
  dispatchGetCrews,
  dispatchDeleteCrew,
  currentUserAppRoles,
  dispatchEditCrewOnSubmit,
  dispatchCreateCrewOnSubmit,
  dispatchInitializeEditCrew,
}) => {
  useEffect(() => {
    dispatchGetCrews();
  }, [dispatchGetCrews]);

  const columns = useMemo(
    () => [
      {
        xs: true,
        title: "Name",
        getSortProperty: item => item.get("name"),
      },
      {
        xs: true,
        component: Grid,
        title: "Modified by",
        getSortProperty: item => item.get("modifiedBy"),
        getValue: getModifiedByValue,
      },
    ],
    [],
  );

  const actions = useMemo(
    () => [
      getAccessControlButton(
        crudAccessLevel.delete,
        dispatchDeleteCrew,
        <Delete fontSize="small" />,
        "Delete",
      ),
    ],
    [crudAccessLevel, dispatchDeleteCrew],
  );

  return (
    <CrudBasePage
      Icon={Icon}
      title={breadcrumb}
      items={crews}
      displayAddButton={hasRequiredAccessLevel(
        crudAccessLevel.create,
        currentUserAppRoles,
      )}
      displaySearchField
      dataState={dataState}
      EditEntityFormComponent={CrewForm}
      CreateEntityFormComponent={CrewForm}
      SortableListProps={{
        defaultSortColumn: 0,
        actions: actions,
        columns: columns,
        getKey: crew => crew.get("id"),
        onRowClick: hasRequiredAccessLevel(
          crudAccessLevel.edit,
          currentUserAppRoles,
        )
          ? dispatchInitializeEditCrew
          : null,
        defaultSortDirection: SORT_DIRECTION.ASC,
      }}
      EditModalProps={{
        submitText: "Save",
        title: "Edit crew",
        formTitleField: CREW_FORM.NAME,
        onSubmit: dispatchEditCrewOnSubmit,
      }}
      CreateModalProps={{
        submitText: "Create",
        title: "Create crew",
        onSubmit: dispatchCreateCrewOnSubmit,
      }}
      editEntityForm={{
        form: CREW_FORM.ID,
      }}
      createEntityForm={{
        form: CREW_FORM.ID,
      }}
    />
  );
};

export default compose(
  connect(
    state => ({
      crews: getCrewsFromState(state),
      currentUserAppRoles: getCurrentUserAppRolesFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_CREWS,
        ACTIONS.DELETE_CREW,
      ),
    }),
    {
      dispatchGetCrews: getCrews,
      dispatchEditCrewOnSubmit: editCrewOnSubmit,
      dispatchDeleteCrew: deleteCrew,
      dispatchInitializeEditCrew: initializeEditCrew,
      dispatchCreateCrewOnSubmit: createCrewOnSubmit,
    },
  ),
)(SettingsCrewContainer);
